import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from 'firebase/firestore';
import { CategoryRankingsKind, ICategory } from 'types';

// #region CONVERTERS *******************************************************************
export const categoryToDoc = (cat: ICategory): DocumentData => {
  return {
    id: cat.id,
    category: cat.category,
    categoryLongName: cat.categoryLongName,
    categoryShortName: cat.categoryShortName ?? '',
    categoryDisplayName: cat.categoryDisplayName,
    formatUnit: cat.formatUnit,
    highOrLow: cat.highOrLow,
    kind: cat.kind,
  };
};

export const categoryConverter: FirestoreDataConverter<ICategory> = {
  toFirestore(stats: ICategory): DocumentData {
    return categoryToDoc(stats);
  },

  fromFirestore(docSnap: QueryDocumentSnapshot, options?: SnapshotOptions): ICategory {
    const cat = docSnap.data(options);

    return {
      id: cat.id,
      category: cat.category,
      categoryLongName: cat.categoryLongName,
      categoryShortName: cat.categoryShortName ?? '',
      categoryDisplayName: cat.categoryDisplayName,
      formatUnit: cat.formatUnit,
      highOrLow: cat.highOrLow,
      kind: cat.kind ?? CategoryRankingsKind.Offense,
    };
  },
};
// #endregion
